import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Privacy from 'features/privacy/Privacy'
import Layout from 'components/layout/Layout'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import { Header } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'

const PrivacyPage = (props) => {
  // i18n
  const { t } = useTranslation('common')

  return (
    <Layout>
      <Header docked title={t('disclaimer')} shape="s4" color="accent-soft" />
      <Privacy {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, DEFAULT_NAMESPACES, i18nConfig))
    }
  }
}

export default PrivacyPage
